import { render, staticRenderFns } from "./PricingComponent.vue?vue&type=template&id=5758efe6&scoped=true"
import script from "./PricingComponent.vue?vue&type=script&lang=js"
export * from "./PricingComponent.vue?vue&type=script&lang=js"
import style0 from "./PricingComponent.vue?vue&type=style&index=0&id=5758efe6&prod&lang=scss&scoped=true"
import style1 from "./PricingComponent.vue?vue&type=style&index=1&id=5758efe6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5758efe6",
  null
  
)

export default component.exports